import React from "react";
import { Box, Container, Grid } from "@mui/material";
import "./Skills.css";
import exp from "../../asset/img/exp.svg";
import html from "../../asset/img/html.svg";
import js from "../../asset/img/js.svg";
import react from "../../asset/img/react.svg";
import node from "../../asset/img/node.svg";

const Skills = () => {
  return (
    <Container sx={{ mt: 15, mb: 10 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} className="aboutImg">
          <h2 style={{ fontSize: 26, marginBottom: 20 }}>Skills</h2>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box className="expCard">
                <img src={html} alt="" />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="expCardRight">
                <img src={js} alt="" />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className="expCard">
                <img src={react} alt="" />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="expCardRight">
                <img src={node} alt="" />
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={5} className="aboutImg">
          <img src={exp} alt="" />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Skills;
